import { freeze } from '@reduxjs/toolkit';
import { IconName } from '../../components/Icon';
import { MessageType } from './types';

export const TOAST_CONTAINER_CLASS_NAME = 'default-toast';
export const CLOSE_AFTER = 10000;
export const ToastIconDictionary = freeze<
  Record<
    MessageType,
    {
      containerColor: string;
      iconName: IconName;
    }
  >
>({
  info: {
    iconName: 'info',
    containerColor: '#0a84ff',
  },
  action: {
    iconName: 'check-circle',
    containerColor: '#008E6C',
  },
  error: {
    iconName: 'warning-circle',
    containerColor: '#D8092F',
  },
});
